import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card card-bordered" }
const _hoisted_2 = { class: "d-flex dropdown-menu-card justify-content-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  class: "form-group",
  style: {"display":"inline-block"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  style: {"margin-left":"20px"}
}, "Search", -1)
const _hoisted_7 = { class: "d-flex align-items-center position-relative" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_9 = {
  class: "form-group",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "form-group m-3",
  style: {"display":"inline-block"}
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary btn-sm",
    type: "submit",
    style: {"margin-top":"25px"}
  }, "Go")
], -1)
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle table-row-dashed fs-7 gy-5 dataTable no-footer" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("td", null, "ID"),
    /*#__PURE__*/_createElementVNode("td", null, " "),
    /*#__PURE__*/_createElementVNode("td", null, "Name"),
    /*#__PURE__*/_createElementVNode("td", null, "Payout"),
    /*#__PURE__*/_createElementVNode("td", null, "Model"),
    /*#__PURE__*/_createElementVNode("td", null, "Geo"),
    /*#__PURE__*/_createElementVNode("td", null, "OS"),
    /*#__PURE__*/_createElementVNode("td", null, "Caps"),
    /*#__PURE__*/_createElementVNode("td", null, "Status"),
    /*#__PURE__*/_createElementVNode("td", null, "Reason"),
    /*#__PURE__*/_createElementVNode("td", null, " ")
  ])
], -1)
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_15 = { class: "symbol symbol-50px me-5" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "col-caps" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_export_report = _resolveComponent("button-export-report")!
  const _component_card_toolbar_menu_item = _resolveComponent("card-toolbar-menu-item")!
  const _component_card_toolbar_menu = _resolveComponent("card-toolbar-menu")!
  const _component_dw_loader = _resolveComponent("dw-loader")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_active_offers_selector = _resolveComponent("active-offers-selector")!
  const _component_is_vta_offers_selector = _resolveComponent("is-vta-offers-selector")!
  const _component_is_state_targeting_offers_selector = _resolveComponent("is-state-targeting-offers-selector")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_card_toolbar_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_card_toolbar_menu_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_button_export_report, {
                  class: "btn-sm",
                  export_type: "csv",
                  entity_endpoint_name: "/partners/offers/getList",
                  filename: "offers_report",
                  noButtonStyling: true,
                  payload: _ctx.getListPayload('csv')
                }, null, 8, ["payload"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_dw_loader, { active: _ctx.busy }, null, 8, ["active"]),
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)), ["prevent"])),
          style: {"width":"100%","display":"flex","align-items":"center"}
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-solid ps-14 form-control-sm",
                type: "text",
                placeholder: "Search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.keyword) = $event))
              }, null, 512), [
                [_vModelText, _ctx.filters.keyword]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_active_offers_selector, {
              modelValue: _ctx.filters.effective_status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.effective_status) = $event)),
              style: {"margin-left":"20px"}
            }, null, 8, ["modelValue"]),
            _createVNode(_component_is_vta_offers_selector, {
              modelValue: _ctx.filters.is_vta,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.is_vta) = $event)),
              style: {"margin-left":"20px"}
            }, null, 8, ["modelValue"]),
            _createVNode(_component_is_state_targeting_offers_selector, {
              modelValue: _ctx.filters.is_state_targeting,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.is_state_targeting) = $event)),
              style: {"margin-left":"20px"}
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_10
        ], 32),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (r) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(r.id), 1),
                  _createElementVNode("td", null, [
                    (r.asset_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("img", {
                              src: r.asset_icon
                            }, null, 8, _hoisted_16)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(r.name), 1),
                  _createElementVNode("td", null, _toDisplayString(r.payout), 1),
                  _createElementVNode("td", null, _toDisplayString(r.payout_model), 1),
                  _createElementVNode("td", null, _toDisplayString(r.country), 1),
                  _createElementVNode("td", null, _toDisplayString(r.platform), 1),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", null, "Im: " + _toDisplayString(r.current_impression_count) + " / " + _toDisplayString(r.daily_impression_cap), 1),
                    _createElementVNode("div", null, "Cl: " + _toDisplayString(r.current_click_count) + " / " + _toDisplayString(r.daily_click_cap), 1),
                    _createElementVNode("div", null, "Cv: " + _toDisplayString(r.current_reported_conversion_count) + " / " + _toDisplayString(r.daily_conversion_cap || r.offer_daily_conversion_cap || 0), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(r.effective_status), 1),
                  _createElementVNode("td", null, _toDisplayString(r.effective_status === "active" ? null : r.o_effective_status_reason || r.p_effective_status_reason), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_router_link, {
                      class: "btn btn-link",
                      to: {name:'offer-view', params: {id: r.id}}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 256))
            ])
          ])
        ]),
        _createVNode(_component_pagination, {
          modelValue: _ctx.pagination,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pagination) = $event)),
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadData()))
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}